import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";

export const IconButton = ({
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<"button">) => (
  <button
    type="button"
    className={classNames(
      "hover:bg-secondary size-5 items-center justify-center rounded-sm transition-colors",
      className,
    )}
    {...props}
  >
    {children}
  </button>
);
